var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"vz-field-message",class:{ 'vz-error': _vm.type === 'error', 'vz-info': _vm.type === 'info' }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }